/**
 * Created by Jan on 22.04.2017.
 */

(function (Lfl, $, undefined) {

    /*
     |===============================================================================================================
     | Namespace definition
     |===============================================================================================================
     */

    /**
     * A namespace that contains objects and classes related to animating elements on the page.
     *
     * @memberOf Lfl
     */
    Lfl.Animations = Lfl.Animations || {};

    (function (Animations, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Animations, 'Animations')) {
            return;
        }

        /*
         |-------------------------------------------------------------------------------------------------------------------
         | Public constants
         |-------------------------------------------------------------------------------------------------------------------
         */

        var constants =
            /**
             * The constants provided by this namespace.
             *
             * @memberOf Lfl.Animations
             */
            Animations.constants = {
                /** @type {int} How long the transitions run in CSS by default. */
                BASE_CSS_TRANSITION_DURATION: 300,
                /*
                 |-------------------------------------------------------------------------
                 | Flashing */
                EDGE_FLASH_FLASHING_CLASS: 'lfl-edge-flashing',
                EDGE_FLASH_CLASS: 'lfl-edge-flash',

                /*
                 |-------------------------------------------------------------------------
                 | Roles of elements on page
                 |---------------------------
                 | TODO MOBA II - might belong to another class. */
                PAGE_ROLE_ATTRIBUTE_NAME: 'data-lfl-page-role',
                NAVIGATION_TOP_ROLE: 'navigation-top'
            };

        /**
         * The default duration of transition in Javascript.
         *
         * Currently depends on the base CSS transition value.
         * @type {number}
         */
        constants.DEFAULT_TRANSITION_DURATION = constants.BASE_CSS_TRANSITION_DURATION + 100;
        /**
         * The duration of window edge flashing animation.
         *
         * It may flash multiple times after one other.
         * @type {int}
         */
        constants.EDGE_FLASH_TRANSITION_DURATION = constants.DEFAULT_TRANSITION_DURATION;

        // Lock down the constants and then the access to them.
        Object.freeze(Animations.constants);
        Object.defineProperty(Animations, "constants", {configurable: false, writable: false});


        /*
         |-----------------------------------------------------------------------------------------------------------
         | Public methods
         |-----------------------------------------------------------------------------------------------------------
         */

        /**
         * Parses out the box shadow property of the given element and returns it in a meaningful fashion.
         *
         * Source: http://stackoverflow.com/a/2683393/5500468
         *
         * Warning: this method is sometimes glitchy and should be used with care.
         * - It seems that the browser sometimes returns inconsistent values during scrolling.
         * - TODO MOBA II - try to fix this by examining the usage of this method in notifications-animator.js
         * -- Possible solutions: caching; determine the cause (probably when the elements is not visible?) and cache?
         *
         * @memberOf Lfl.Animations
         * @param {jQuery} $element
         * @return {{hasShadow: boolean, x:int, y:int, blur:int, color: string}}
         */
        Animations.getBoxShadowDetails = function ($element) {
            var string = window.getComputedStyle($element[0])["box-shadow"];
            var pixelSplits = string.match(/(-?\d+px)/g);
            var colorSplits = string.match(/(rgb\(.+\))/g);

            // TODO Moba II - expand upon this to enable all possible units (em, ex, %, px, cm, mm, in, pt, pc).
            // - Var A (worse): by cycling through and splitting the string on those (you have to construct groups
            // according to the px group, not to run multiple match splits - the order of x, y, blur, ... would get
            // broken otherwise. ).
            // - Var B (better): just first remove the color via the colorSplits and then split on numbers. That will be
            //   unit-agnostic.

            if (pixelSplits !== null && pixelSplits.length >= 3) {
                return {
                    hasShadow: true,
                    x: parseInt(pixelSplits[0], 10),
                    y: parseInt(pixelSplits[1], 10),
                    blur: parseInt(pixelSplits[2], 10),
                    // No idea how but sometimes the color splits do not get loaded when pixel splits do.
                    color: (colorSplits !== null && colorSplits.length > 0) ? colorSplits[0] : undefined
                };
            } else {
                return {
                    hasShadow: false,
                    x: 0,
                    y: 0,
                    blur: 0,
                    color: 'rgb(123, 456, 789)'
                };
            }
        };

        /*
         |-----------------------------------------------------------------------------------------------------------
         | Private methods
         |-----------------------------------------------------------------------------------------------------------
         */
    }(Lfl.Animations, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
